import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import CommercialPage from "@/pages/CommercialPage";
import ResidentialPage from "@/pages/ResidentialPage";
import PricingPage from "@/pages/PricingPage";
import ReviewsPage from "@/pages/ReviewsPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import AdminResetPage from "@/pages/AdminResetPage";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/reset" element={<AdminResetPage />} />
            <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="commercial" element={<CommercialPage />} />
            <Route path="residential" element={<ResidentialPage />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="reviews" element={<ReviewsPage />} />
            <Route path="contact" element={<ContactPage />} />
          </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
